import { FileText } from "lucide-react";

const manifest = {
  key: "offers_management",
  isFreeModule: false,
  isPurchasable: true,
  icon: FileText,
  names: {
    plan: {
      en: "All Tenders",
      ar: "\u062c\u0645\u064a\u0639 \u0627\u0644\u0645\u0646\u0627\u0641\u0633\u0627\u062a",
    },
    dashboard: {
      en: "All Tenders",
      ar: "\u062c\u0645\u064a\u0639 \u0627\u0644\u0645\u0646\u0627\u0641\u0633\u0627\u062a",
    },
   
  },
  defaultPath: "/offers-dashboard",
  matchers: [
    /^\/offers-dashboard(?:\/|$)/,
    /^\/all-tenders(?:\/|$)/,
    /^\/my-offers(?:\/|$)/,
    /^\/submitOffer\/[^/]+(?:\/|$)/,
    /^\/myoffer\/[^/]+(?:\/|$)/,
  ],
  buildNavbarMenus: ({ t, activeModuleLabel, ALL_TENDERS_ENABLED }) => [
    {
      label: activeModuleLabel,
      path: "__offers_management__",
      children: [
        { label: t("dashboard"), path: "/offers-dashboard" },
        {
          label: t("All_Tenders"),
          path: "/all-tenders",
          disabled: !ALL_TENDERS_ENABLED,
          disabledReason: !ALL_TENDERS_ENABLED ? "soon" : undefined,
        },
        {
          label: t("MyOffers"),
          path: "/my-offers",
          permissions: [
            "view_all_submissions",
            "view_my_submissions",
          ],
        },
        {
          label: t("menu_approvals_requests_management"),
          path: "/incoming-invitations",
          permissions: ["accept_reject_invitations"],
        },
      ],
    },
  ],
};

export default manifest;
